import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiPesquisaService } from '../../services/api-pesquisa.service';

export const semPesquisaPendenteGuard: CanActivateFn = () => {

  const router = inject(Router);
  const apiPesquisa = inject(ApiPesquisaService);

  return apiPesquisa.pesquisaPendente().pipe(
    map(pesquisa => pesquisa ? router.parseUrl('/sistemas/pesquisa') : true),
    catchError(() => of(true))
  );
};
